import React, { Component } from 'react'
import Icon from '@material-ui/core/Icon'

import InputField from '../controls/InputField'

class PasswordField extends Component {
  constructor () {
    super()
    this.togglePass = this.togglePass.bind(this)
    this.input = undefined
    this.state = {
      passType: 'password'
    }
  }

  togglePass (e) {
    let passType = this.state.passType
    passType === 'password' ? passType = 'text' : passType = 'password'

    this.setState({ passType })
  }

  render () {
    let button = this.state.passType === 'password' ? <Icon onClick={this.togglePass} viewBox='0 0 35 35'>visibility</Icon> : <Icon onClick={this.togglePass} viewBox='0 0 35 35'>visibility_off</Icon>
    const adorn = this.props.adornment ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'inherit' }}>{button}{this.props.adornment}</div> : button

    return (
      <div>
        <InputField
          {...this.props}
          type={this.state.passType}
          ref={textField => { this.input = textField ? textField.input : undefined }}
          adornment={adorn} />
      </div>
    )
  }
}

export default PasswordField



// WEBPACK FOOTER //
// ./src/controls/PasswordField.js